<template>
    <AddFileSection
        :id="AddFileFormSectionIds.REQUEST_IDENTITY_VERIFICATION"
        sectionDescription="Select clients to complete identity verification for this file."
        sectionHeading="Request identity verification"
    >
        <ClientMultiSelect
            class="mt-3"
            :error="requestIDVRecipientsError"
            :name="REQUEST_IDV_NAME"
            :required="false"
            @update:modelValue="onClientsUpdate"
        />
    </AddFileSection>
</template>

<script setup lang="ts">
import { useAddFileStore } from '@/company-portal/add-file/add-file.store';
import { AddFileFormSectionIds } from '@/company-portal/add-file/add-file.types';
import { REQUEST_IDV_NAME } from '@/company-portal/add-file/selectors';
import { clearServerValidationError, serverValidationErrors } from '@/company-portal/add-file/submission-error';
import AddFileSection from '@/components/Views/Company/AddFile/AddFileSection.vue';
import ClientMultiSelect from '@/components/Views/Company/AddFile/ClientMultiSelect.vue';
import type { DsMultiSelectClientOption } from '@/components/Views/Company/AddFile/useClientMultiSelect';
import { computed } from 'vue';

const addFileStore = useAddFileStore();

const onClientsUpdate = (clients: DsMultiSelectClientOption[]) => {
    addFileStore.requestIdvClientIds = clients.map(client => client.id);
    clearServerValidationError('requestIdVerification_recipients');
};

const requestIDVRecipientsError = computed(
    () => serverValidationErrors.value?.['requestIdVerification_recipients']?.join('') ?? '',
);
</script>
